module.exports = __webpack_public_path__ + "img/img-160721.jpg";